import { useApiQuery } from '../../../../common/infrastructure/hooks/useApiQuery';
import { endpointsMetadata } from '../../../../common/infrastructure/routes/endpointsMetadata';
import { IGroupClassInstructor } from '../models';

/**
 * Hook to fetch instructors available for a specific class
 * Includes "Без значение" (any instructor) option with id = -1
 */
export const useGroupClassInstructors = (
  className: string | undefined,
  studioId: number | undefined
) => {
  const { data, isLoading, error } = useApiQuery<IGroupClassInstructor[]>({
    queryKey: [endpointsMetadata.groupClasses.getInstructors, className, studioId],
    endpoint: `${endpointsMetadata.groupClasses.getInstructors}?className=${encodeURIComponent(className!)}&studioId=${studioId}`,
    enabled: !!className && !!studioId,
    globalIsLoading: false,
  });

  return {
    instructors: data ?? [],
    isLoading,
    error,
    hasData: !!data && data.length > 0,
  };
};
